import { QueryClient } from '@tanstack/react-query'
import { ApiError } from './api'

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			// Admin data is read to make decisions, so stale reads are worse than
			// an extra request. Short window to de-duplicate a burst of renders.
			staleTime: 10_000,
			refetchOnWindowFocus: false,
			retry: (failureCount, error) => {
				// Never retry an expired session or a refused action — retrying
				// only delays showing the operator what actually happened.
				if (error instanceof ApiError && error.status < 500) return false
				return failureCount < 2
			},
		},
		mutations: { retry: false },
	},
})
